import styled from "styled-components";

export const Section = styled.section`
  background-color: var(--dental-gray-50);
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;

  @media (min-width: 640px) {
    max-width: 640px;
  }

  @media (min-width: 768px) {
    max-width: 768px;
  }

  @media (min-width: 1024px) {
    max-width: 1024px;
  }

  @media (min-width: 1280px) {
    max-width: 1280px;
  }

  @media (min-width: 1536px) {
    max-width: 1536px;
  }
`;

export const Header = styled.div`
  max-width: 48rem;
  margin: 0 auto 4rem;
  text-align: center;
`;

export const Badge = styled.span`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background-color: #e0f2fe;
  color: ${({ theme }) => theme.colors.primary[3]};
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 1rem;
`;

export const Title = styled.h2`
  font-size: 2rem;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primaryText[9]};
  margin-bottom: 1.5rem;
  @media (min-width: 768px) {
    font-size: 2.5rem;
  }
`;

export const Description = styled.p`
  font-size: 1.125rem;
  color: ${({ theme }) => theme.colors.primaryText[8]};
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const PlanCard = styled.div<{ featured: boolean }>`
  border-radius: 1rem;
  overflow: hidden;
  transition: all 0.3s;
  &:hover {
    transform: translateY(-4px);
  }
  ${({ featured }) =>
    featured
      ? `
    background-color: white;
    border: 1px solid #0C6ACB;
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
    position: relative;
  `
      : `
    background-color: white;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
  `}
`;

export const FeaturedTag = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  background-color: #0c6acb;
  color: white;
  padding: 0.25rem 1rem;
  border-bottom-left-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
`;

export const PlanContent = styled.div`
  padding: 2rem;
`;

export const PlanTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primaryText[9]};
  margin-bottom: 0.5rem;
`;

export const PlanDescription = styled.p`
  color: ${({ theme }) => theme.colors.primaryText[8]};
  margin-bottom: 1rem;
`;

export const PlanPrice = styled.div`
  margin-bottom: 1rem;
  font-size: 2rem;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primaryText[9]};
`;

export const PlanBillingType = styled.span`
  font-size: 0.875rem;
  font-weight: 400;
  margin-left: 0.25rem;
`;

export const PlanFeatures = styled.ul`
  margin-bottom: 2rem;
  list-style: none;
  padding: 0;
`;

export const PlanFeature = styled.li<{ featured: boolean }>`
  display: flex;
  align-items: start;
  gap: 0.75rem;
  color: ${({ theme }) => theme.colors.primaryText[8]};
  &:before {
    content: "\2713";
    display: inline-block;
    background-color: ${({ featured }) =>
      featured ? "#" : "var(--dental-gray-100)"};
    color: ${({ featured }) => (featured ? "#" : "#343A40")};
    border-radius: 50%;
    padding: 0.25rem;
    font-size: 0.875rem;
  }
`;

export const FeatureIcon = styled.div<{ featured: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${({ featured }) => (featured ? "#e0f2fe" : "#F3F4F6")};
  color: ${({ featured }) => (featured ? "#0C6ACB" : "#343A40")};
`;

export const PlanButton = styled.button<{ featured: boolean }>`
  width: 100%;
  border: none;
  border-radius: 9999px;
  padding: 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
  ${({ featured }) =>
    featured
      ? `
    background-color: #0C6ACB;
    color: white;
    &:hover {
      background-color: #084C93;
    }
  `
      : `
    background-color: #F3F4F6;
    color: #212529;
    &:hover {
      background-color:#E5E7EB;
    }
  `}
`;

export const FooterText = styled.p`
  margin: auto;
  margin-top: 3rem;
  text-align: center;
  max-width: 700px;
  text-align: center;
  color: ${({ theme }) => theme.colors.primaryText[8]};
  font-size: 1rem;
`;
